import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles(() => ({
  header: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "32px",
    marginBottom: 25
  },

  content: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
  },

  arrowRightIcon: {
    marginLeft: 8,
  },

  text: {
    fontSize: 16,
    lineHeight: "24px",
    marginRight: 24,
    color: colors.darkBlue900,
  },

  textContainer: {
    display: "flex",
    alignItems: "center",
    color: colors.ideGreen500,
    fontWeight: 700,
  },

  secondary: {
    width: "100%",
    maxWidth: 315,

    '& > :last-child': {
      marginBottom: 0,
    },
  },
}));

export { useStyles }
